<div class="main-content-container" *ngIf="resourceDef">
  <div class="main-container-body">
    <div class="page-title-container d-flex" *ngIf="checkPage()">
      <div class="page-title flex-grow-1 ng-star-inserted" *ngIf="!utilService.isMobile()">
        <div class="mb-0 ng-star-inserted">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2 ng-star-inserted"><a class="d-inline-flex" (click)="previous()"
                href="javascript:void(0)"><img src="assets/images/grid-back.png"></a></div>
            <div class="">{{resourceDef.page_name.list | translate | async}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-ui-engine-container layout_simple layout_simple_holiday_calender main-box-shadow"
      *ngIf="!isCustomComponentLoaded">
      <div class="d-flex flex-wrap align-items-center pr-3 event-calender-header ">
          <dhs-form class="flex-grow-1" #formsize  *ngIf="resourceDef" [action]="'ADD'" [config]="config"
          [fieldGroup]="resourceDef.form"  #decorator (questionValueChanged)="schedulerChange($event)">
        </dhs-form>
        <div *ngIf="defaultCalender" class="d-flex flex-grow-1 pb-2" [ngClass]="summaryData?'seleted_calender':''">
          <div class="btn btn-light" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
            (viewDateChange)="closeOpenMonthViewDay()"><i class="fa fa-angle-left" aria-hidden="true"></i></div>
          <h3 class="mt-2 px-2">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
          <div class="btn btn-light ml-1" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
            (viewDateChange)="closeOpenMonthViewDay()">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </div>
        </div>
        <div class="flex-grow-1" *ngIf="!summaryData">
          <div class="_wf-pp-jumptocalender w-clearfix float-right" style="width: 125px;">
            <div class="input-group">
              <div class="">
                <span class="">
                  <label for="dateToInput1">{{'field.label.jump_to_a_date' | translate | async}} <i class="fa fa-calendar"></i></label>
                </span>
              </div>
              <input type="text" style="display: none" id="dateToInput1" ngxDaterangepickerMd
                class="form-control choose-date datepicker-search" placeholder="Choose date" showCancel="true"
                [singleDatePicker]="true" [locale]="locale" [showClearButton]="false" [opens]="'center'"
                [showDropdowns]="true" (datesUpdated)="onChange($event)" />
            </div>
          </div>
        </div>
        <div class="w-100 pl-3">
          <div class="cal-pill">
            <div class="d-inline-flex calender-pills" *ngIf="title">
              <div class="flex-grow-1 mr-1" style="color: black;">
                {{title}}
              </div>
              <div class="">
                <i class="fa fa-times-circle-o"></i>
              </div>
            </div>
          </div>
          <div class="_wf-db-webrgtpointsdiv mt-1" *ngIf="resourceDef && resourceDef.dot_color">
            <div class="_wf-db-bedspoints-dots" *ngFor="let dot of resourceDef.dot_color">
              <span class="dot"
                [ngStyle]="{'background-color':dot.bgColor,'border':'1px solid','border-color':dot.border_color}"></span>
              {{dot.text | translate |async}}
            </div>
          </div>
          <div class="_wf-db-webrgtpointsdiv mt-1"
            *ngIf="resourceDef && resourceDef.eventCount && (scheduledOt || completedOt)">
            <div class="_wf-db-bedspoints-dots">
              <span class="dot" style="background-color:#1e90ff"></span>
              <span> {{scheduledOt?scheduledOt:'0'}}</span>
              Scheduled
            </div>
            <div class="_wf-db-bedspoints-dots">
              <span class="dot" style="background-color:#7FFF00"></span>
              <span> {{completedOt?completedOt:'0'}}</span>
              Completed
            </div>
            <!-- <div class="_wf-db-bedspoints-dots">
              <span class="dot" style="background-color:#e3bc08"></span>
              <span> {{requestedOt?requestedOt:'0'}}</span>
              Requested
            </div> -->
          </div>
          <br />
          <div [ngSwitch]="view">
            <div *ngIf="!summaryData">
              <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events"
                [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)"
                (hourSegmentClicked)="hourSegmentClicked('Clicked', $event)"
                (eventClicked)="handleEvent('Clicked', $event.event)">
              </mwl-calendar-month-view>
            </div>
            <div *ngIf="!summaryData" class="scheduler-wrapper">
              <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [dayStartHour]="dayStartHour"
                [dayEndHour]="dayEndHour" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
                (eventClicked)="handleEvent('Clicked', $event.event)" [hourSegments]="hourSegments"
                (hourSegmentClicked)="hourSegmentClicked('Clicked', $event)">
              </mwl-calendar-week-view>
            </div>
            <div *ngIf="!dayView && !summaryData">
              <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [dayStartHour]="dayStartHour"
                [dayEndHour]="dayEndHour" [viewDate]="viewDate" [hourSegments]="hourSegments" [events]="events"
                [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)">
              </mwl-calendar-day-view>
            </div>
            <div *ngIf="dayView" class="scheduler-wrapper">
              <mwl-day-view-scheduler *ngSwitchCase="CalendarView.Day" [hourSegments]="hourSegments"
                [dayStartHour]="dayStartHour" [dayEndHour]="dayEndHour" [viewDate]="viewDate" [events]="event"
                [users]="user" [refresh]="refresh" (slotResult)="slotResult($event)"
                (hourSegmentClicked)="hourSegmentClicked('Clicked', $event)" (eventClicked)="closeaSidebar($event)">
              </mwl-day-view-scheduler>
            </div>
            <!-- calendar.component.html -->
            
              <!-- calendar.component.html -->
          </div>
        </div>
      </div>
    </div>
